class a {
  fullUrl;
  productCode;
  regionCode;
  nameVariation;
  constructor(r, o, i, t) {
    this.fullUrl = r, this.productCode = o, this.regionCode = i, this.nameVariation = t;
  }
}
export {
  a as SearchCriteria
};
//# sourceMappingURL=index.js.map
